import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'dc-close-confirm-icon',
  templateUrl: './close-confirm-icon.component.html',
  styleUrls: ['./close-confirm-icon.component.scss']
})
export class CloseConfirmIconComponent implements OnInit {

  constructor() { }

  @Output() confirm = new EventEmitter();
  title: string = "确定要关闭?";
  ngOnInit(): void {
  }
}
